import { o_util } from "@gr-common/body/namespaces";
import { otto } from "@gr-exports/body/nexus";
const dom = o_util?.dom ?? {};
const stringToDocumentFragment = dom.stringToDocumentFragment;
const getFirstElementByTagName = dom.getFirstElementByTagName;
const getHeadElement = dom.getHeadElement;
const getBodyElement = dom.getBodyElement;
const onLoad = otto.dom?.onLoad;
const onReady = otto.dom?.onReady;
export {
  dom,
  getBodyElement,
  getFirstElementByTagName,
  getHeadElement,
  onLoad,
  onReady,
  stringToDocumentFragment
};
